import { render } from "./movablespledge-count.vue?vue&type=template&id=35518000&scoped=true"
import script from "./movablespledge-count.vue?vue&type=script&lang=js"
export * from "./movablespledge-count.vue?vue&type=script&lang=js"

import "./movablespledge-count.vue?vue&type=style&index=0&id=35518000&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35518000"]])

export default __exports__